/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getIndividualTaxInformationStatus} from '../api'

 export const useQueryGetIndividualTaxInformationStatus = createReactQueryHook('getIndividualTaxInformationStatus', getIndividualTaxInformationStatus)
